/**
 * @file   : TextCards.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 8:07:14 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import SimpleContainer from '../../../external/components/container/SimpleContainer'
import ACol from '../../../external/components/layout/ACol'
import AGrid from '../../../external/components/layout/AGrid'
import ARow from '../../../external/components/layout/ARow'
import Cont from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import Article from '../../home/article/Article'
import HackMarketingContentWrapper from '../../sharedInternal/container/HackMarketingContentWrapper'
import {
  getArticleFromContent,
  getLinkObj,
  isData,
  redirectToDestination,
} from '../InfoUtil'
import SectionAd from './SectionAd'
import SectionDescription from './SectionDescription'
import SectionHeader from './SectionHeader'

const TextCards = ({ intl, theme, section, infoData, mainConfig }) => {
  const getArticleCard = function (content) {
    const article = getArticleFromContent(intl, content, infoData)

    return (
      <Article
        theme={theme}
        intl={intl}
        getArticleSelectLinkObj={getLinkObj}
        article={article}
        onArticleSelectRequest={redirectToDestination}
      />
    )
  }

  if (isData(section) && section.showSection) {
    let row1 = null
    let row2 = null

    row1 = (
      <ARow>
        <ACol xs={12} sm={6} md={3} lg={3}>
          {getArticleCard(section.content[0])}
        </ACol>
        <ACol xs={12} sm={6} md={3} lg={3}>
          {getArticleCard(section.content[1])}
        </ACol>
        <ACol xs={12} sm={6} md={3} lg={3}>
          {getArticleCard(section.content[2])}
        </ACol>
        <ACol xs={12} sm={6} md={3} lg={3}>
          {getArticleCard(section.content[3])}
        </ACol>
      </ARow>
    )

    if (section.content.length > 4) {
      row2 = (
        <Cont hideXS>
          <ARow>
            <ACol xs={12} sm={6} md={3} lg={3}>
              {getArticleCard(section.content[4])}
            </ACol>
            <ACol xs={12} sm={6} md={3} lg={3}>
              {getArticleCard(section.content[5])}
            </ACol>
            <ACol xs={12} sm={6} md={3} lg={3}>
              {getArticleCard(section.content[6])}
            </ACol>
            <ACol xs={12} sm={6} md={3} lg={3}>
              {getArticleCard(section.content[7])}
            </ACol>
          </ARow>
        </Cont>
      )
    }

    return (
      <HackMarketingContentWrapper>
        <SimpleContainer>
          <Cont>
            <SectionHeader intl={intl} section={section} infoData={infoData} />
            <SectionDescription
              intl={intl}
              section={section}
              infoData={infoData}
            />
            <AGrid fluid>
              {row1}
              {row2}
            </AGrid>
          </Cont>
        </SimpleContainer>
        <SectionAd section={section} mainConfig={mainConfig} />
        <Section />
      </HackMarketingContentWrapper>
    )
  }

  return null
}

TextCards.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default TextCards
